import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormCompanies', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/companies/issue_form_companies.html'),
        controller: 'IssueFormCompaniesController',
        controllerAs: 'IssueFormCompaniesCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            company: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/companies/issue_form_companies.component.ts